export default class ProgressData {
  timer = null

  constructor (options = {}) {
    this.mockPercent = options.mockPercent || 80
    this.mockData = this.mockPercent
  }

  update(percent, cb) {
    if (percent === true) {
      this.clear()
      this.timer = setInterval(() => {
        cb(this.mockData++)
        if (this.mockData > 100) {
          this.clear()
          this.mockData = this.mockPercent
        }
      }, 50)
    } else if (percent < 1) {
      cb(parseInt(percent * this.mockPercent))
    } else {
      this.timer = setInterval(() => {
        if (this.mockData < 100) {
          cb(this.mockData++)
        } else {
          this.clear()
        }
      }, 200)
    }
  }

  clear() {
    clearInterval(this.timer)
  }
}